// src/components/Blogs.js
import { blogs } from "../data/blogs.js";

const byPriorityAsc = (a, b) => {
  const pa = a.priority ?? "low";
  const pb = b.priority ?? "low";
  if (pa === "high" && pb !== "high") return -1;
  if (pb === "high" && pa !== "high") return 1;
  const yearA = a.year ?? 0;
  const yearB = b.year ?? 0;
  return yearB - yearA; // newest first
};

export default function Blogs() {
  const sortedBlogs = [...blogs]
  .slice(0, 4)
  .sort(byPriorityAsc);

  return (
    <section>
      {/* Header row */}
      <div className="flex items-center justify-between pt-5 pb-3">
        <h2 className="text-[#0e1b17] text-[22px] font-bold leading-tight tracking-[-0.015em] px-4 md:px-0 pb-3 pt-5">
          Our Activities
        </h2>
        <a
          href="/blogs"
          className="text-sm font-semibold text-[#14b881] hover:underline whitespace-nowrap"
        >
          View All
        </a>
      </div>

      {/* Mobile: horizontal scroll | Desktop: grid */}
      <div
        className="md:hidden flex overflow-x-auto gap-3 p-4 [-ms-scrollbar-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        aria-label="Blogs slider"
      >
        {sortedBlogs.map(({ title, subtitle, image, link }, i) => (
          <article
            key={i}
            className="bg-white rounded-xl border border-[#e7f3ef] shadow-sm overflow-hidden flex flex-col min-w-[15rem] w-60"
          >
            <div className="p-4 flex flex-col gap-2 flex-1">
              <p className="text-[#0e1b17] text-base font-medium leading-normal">
                {title}
              </p>
              <p className="text-[#4e977f] text-sm leading-normal line-clamp-3">
                {subtitle}
              </p>
            </div>
            {link && (
              <div className="mt-4 mb-4 flex justify-center">
                <a
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-3 inline-flex items-center justify-center self-start rounded-lg bg-[#14b881] px-4 py-2 text-xs sm:text-sm font-semibold text-[#0e1b17] hover:bg-[#0fa46f] transition"
                >
                  View
                </a>
              </div>
            )}
          </article>
        ))}
      </div>

      {/* Desktop: grid layout */}
      <div className="hidden md:grid lg:grid-cols-4 grid-cols-2 gap-4 p-4">
        {sortedBlogs.map(({ title, subtitle, image, link }, i) => (
          <article
            key={i}
            className="bg-white rounded-xl border border-[#e7f3ef] shadow-sm overflow-hidden flex flex-col w-full"
          >
            <div className="p-4 flex flex-col gap-2 flex-1">
              <p className="text-[#0e1b17] text-base font-medium leading-normal">
                {title}
              </p>
              <p className="text-[#4e977f] text-sm leading-normal line-clamp-3">
                {subtitle}
              </p>
            </div>
            {link && (
              <div className="mt-4 mb-4 flex justify-center">
                <a
                  href={link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-3 inline-flex items-center justify-center self-start rounded-lg bg-[#14b881] px-4 py-2 text-xs sm:text-sm font-semibold text-[#0e1b17] hover:bg-[#0fa46f] transition"
                >
                  View
                </a>
              </div>
            )}
          </article>
        ))}
      </div>
    </section>
  );
}
